export default "__VITE_ASSET__I1FdSYBC__"